export default {
    en: {
        title: "Payments Section",
        apply: "Apply",
        name: 'Name',
        date: 'Date',
        total: 'Total',
        type: 'Payment Type',
        status: 'Payment Status',
        payment: {
            paid: 'Paid',
            debt: 'Debt',
            bonus: 'Bonus',
            canceled: 'Canceled',
            cash: 'Cash',
            card: 'Card',
            bank: 'Bank',
            mixed: 'Mixed'
        },
    },
    uz: {
        title: "To'lovlar bo'limi",
        apply: 'Tasdiqlash',
        name: 'Nomi',
        date: 'Sana',
        total: 'Umumiy',
        type: "To'lov turi",
        status: "To'lov holati",
        payment: {
            paid: "To'langan",
            debt: 'Qarz',
            bonus: 'Bonus',
            canceled: "Bekor Bo'lgan",
            cash: 'Naqt',
            card: 'Karta',
            bank: 'Bank',
            mixed: 'Aralash'
        }
    },
    ru: {
        title: "Раздел платежей",
        apply: 'Применять',
        name: 'Название',
        date: 'Дата',
        total: 'Итого',
        type: 'Виды оплаты',
        status: 'Статус платежа',
        payment: {
            paid: 'Оплаченных',
            debt: 'Долг',
            bonus: 'Бонус',
            canceled: 'Отменено',
            cash: 'Наличные',
            card: 'Карта',
            bank: 'Банк',
            mixed: 'Разный'
        }
    }
}